import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { aiSettingsReducer } from './ai-settings.reducer'
import { EffectsModule } from '@ngrx/effects'
import { AISettingsEffects } from './ai-settings.effects'
import { AiResponderService } from './ai-responder.service'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('aiSettings', aiSettingsReducer),
    EffectsModule.forFeature([AISettingsEffects]),
  ],
  declarations: [],
  providers: [AiResponderService],
})
export class AISettingsStoreModule {}
